import * as React from 'react';
import { useSelector } from 'react-redux';
import { AppPermissionContext } from '@/components/HOCs/AppPermissionContext';
import { RunwayUserAction } from '@/helpers/aclHelpers';
import { RootState } from '@/reducers/reducers';
import { selectUserCanPerformAction } from '@/selectors/selectors';
import { Environment } from '@/types';

export enum UserPermissionScope {
    App = 'app',
    Org = 'org',
}

export const useUserCanPerformAction = (
    actionType: RunwayUserAction | undefined,
    releaseId?: string,
    environment?: Environment,
    bucketId?: string,
    allowDemoMode?: boolean,
    appId?: string,
    permissionScope: UserPermissionScope = UserPermissionScope.App,
): boolean | undefined => {
    const effectiveAppId = useEffectiveAppId(appId, permissionScope);

    return useSelector((state: RootState) =>
        selectUserCanPerformAction(state, actionType, releaseId, environment, bucketId, allowDemoMode, effectiveAppId),
    );
};

export const useEffectiveAppId = (
    appId?: string,
    permissionScope: UserPermissionScope = UserPermissionScope.App,
): string | undefined => {
    const appIdFromRoute = React.useContext(AppPermissionContext);
    return permissionScope === UserPermissionScope.App ? (appId ?? appIdFromRoute) : undefined;
};

export const useUserCanPerformOrgAction = (
    actionType: RunwayUserAction | undefined,
    releaseId?: string,
    environment?: Environment,
    bucketId?: string,
    allowDemoMode?: boolean,
): boolean | undefined =>
    useUserCanPerformAction(
        actionType,
        releaseId,
        environment,
        bucketId,
        allowDemoMode,
        undefined,
        UserPermissionScope.Org,
    );
